import React from 'react'
import withCapabilities from '../../hoc/withCapabilities'
import { useGeneralConfiguration } from '../../features/Configuration/GeneralConfiguration/hooks/useGeneralConfiguration'
import HeaderLogo from './HeaderLogo/HeaderLogo'
import { HeaderContainer, HeaderLogoContainer } from './Header.styled'
import { HeaderBanner } from './HeaderBanner/HeaderBanner'

const Header: React.FC = () => {
  const { logo, banner, bannerTitle, bannerSubtitle, bannerPosition } = useGeneralConfiguration()

  return (
    <HeaderContainer>
      <HeaderLogoContainer>
        <HeaderLogo logo={logo} />
      </HeaderLogoContainer>
      <HeaderBanner src={banner} title={bannerTitle} subtitle={bannerSubtitle} objectPosition={bannerPosition} />
    </HeaderContainer>
  )
}

export default withCapabilities(Header)
